import moment from "moment";

const DATE_FORMAL_FORMAT  = 'YYYY-MM-DD';
const DATE_HUMAN_FORMAT   = 'MMMM D, YYYY';
const DATE_SHORT_FORMAT   = 'MMM DD';

class DateFormatter {

    /**
     * Return the day of the month with 0 padding
     * 
     * @param {string} day - Date
     * 
     * @return {string}
     */
    showDay(day) {
        return moment(day).format('DD');
    }
    
    /**
     * Return a formal date format YYYY-MM-DD
     * 
     * @param {string} date - Date
     * 
     * @return {string}
     */
    toFormal(date) {
        return moment(date).format(DATE_FORMAL_FORMAT);
    }
    
    /**
     * Return a shorten date format (Jan 20) sans year
     * 
     * @param {string} date - Date
     * 
     * @return {string}
     */
    shorten(date) {
        return moment(date).format(DATE_SHORT_FORMAT);
    }
    
    /**
     * Return a full string / humanized format (January 20, 2020)
     * 
     * @param {string} date - Date
     * 
     * @return {string}
     */
    humanized(date) {
        return moment(date).format(DATE_HUMAN_FORMAT);
    }

    /**
     * Set the date range.
     * The date range variables that are set on the ractive instance are
     * are used on the view
     * 
     * @param {string}  from - Range starting date
     * @param {string}  to   - Range ending dates
     * @param {Ractive} app  - Ractive instance
     */
    setDateRange(from, to, app) {
        app.set('dateRange.from', this.toFormal(from));
        app.set('dateRange.to', this.toFormal(to));

        app.set('dateRange.formatted.from', this.humanized(from));
        app.set('dateRange.formatted.to', this.humanized(to));   
    }
}

class Formatter {

    constructor() {
        this.date = new DateFormatter();
    }

    /**
     * Return a formatted hours (2 decimal places)
     * 
     * @param {number} hours - Hours
     * 
     * @return {string}
     */
    formatHours(hours) {
        if (typeof hours !== 'undefined') {
            return hours.toFixed(2);
        }
    
        return 0;
    }

    /**
     * Return a percentage value (0 decimal places)
     * 
     * @param {number} value - Number
     * 
     * @return {string}
     */
    toPercentage(value) {
        return (value * 100).toFixed(0);
    }
}

module.exports = Formatter;